import { render, staticRenderFns } from "./PreguntasMenu.vue?vue&type=template&id=1c4208fd"
import script from "./PreguntasMenu.vue?vue&type=script&lang=js"
export * from "./PreguntasMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports